import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class TextAreaQuestion extends QuestionBase<string> {
  override type = InputType.AREA;
}